import React from "react";
import "./styles.scss";
import { ProductsSection, OfferBanner } from "../../components";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import SEO from "../../components/SEO/SEO";

export default function Products() {
  const { t } = useTranslation();
  useEffect(() => {
    window.scrollTo(0, 0, { behavour: "smooth" });
  }, []);

  return (
    <>
    <SEO
      title={`${t("general.headerProductsAndServices")} | Synergon Energy`}
      name={`${t("general.headerProductsAndServices")} | Synergon Energy`}
      description={t("productsAndServices.usersSubtitle")}
      type={"website"}
      jsonLd={[{
        "@context": "https://schema.org",
        "@type": "Service",
        serviceType: "Energy Products",
        name: "Synergon Energy Products",
  description: t("productsAndServices.productsSeeAll"),
        provider: { "@type": "Organization", name: "Synergon Energy" },
        url: typeof window !== 'undefined' ? window.location.origin + window.location.pathname : "https://synergonenergy.bg/products-and-services"
      }]}
    />
      <div className="screen-wrapper products">
        <div className="screen-inner-wrapper">
          <ProductsSection />
          <OfferBanner />
        </div>
      </div>
    </>
  );
}
